(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('routine-builder')) {
    class RoutineBuilder extends HTMLElement {
      connectedCallback() {
        try {
          this.labels = JSON.parse(this.getAttribute('data-labels') || '{}');
        } catch (e) {
          this.labels = {};
        }
        this.currency = this.getAttribute('data-currency') || 'SEK';
        this.locale = this.getAttribute('data-locale') || 'sv';
        this.shipThreshold = parseInt(this.getAttribute('data-ship-threshold'), 10) || 0;
        this.giftThreshold = parseInt(this.getAttribute('data-gift-threshold'), 10) || 0;
        this.prevTotal = null;
        if (!this._bound) {
          this._bound = true;
          this.addEventListener('change', () => this.compute());
          window.addEventListener('pageshow', () => this.compute());
          this.addEventListener('click', (e) => {
            const cta = e.target.closest('[data-rb-cta]');
            if (cta) this.addAll(cta);
          });
        }
        this.compute();
      }

      fmt(cents) {
        try {
          return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2,
          }).format(cents / 100);
        } catch (e) {
          return Math.round(cents / 100) + ' kr';
        }
      }

      activeLevel() {
        const r = this.querySelector('.rb-radio:checked');
        return r ? parseInt(r.value, 10) : 2;
      }

      picks() {
        const lvl = this.activeLevel();
        const out = [];
        this.querySelectorAll('.rb-step').forEach((step) => {
          if (parseInt(step.getAttribute('data-min-level'), 10) > lvl) return;
          const inc = step.querySelector('.rb-include');
          if (inc && !inc.checked) return;
          const pick = step.querySelector('.rb-pick:checked');
          if (pick) out.push(pick);
        });
        return out;
      }

      compute() {
        // Un-hide JS-only chrome (server renders it hidden for the no-JS path);
        // done on every compute so a Horizon morph re-introducing the attribute heals itself.
        this.querySelectorAll('.rb-js[hidden]').forEach((el) => el.removeAttribute('hidden'));
        const picks = this.picks();
        const giftVariant = this.getAttribute('data-gift-variant') || '';
        // Thresholds count only non-gift products (mirrors the discount's own rule),
        // and a selected gift product costs 0 once the rest clears the threshold.
        let eligible = 0;
        let giftCardPrice = 0;
        picks.forEach((p) => {
          const price = parseInt(p.getAttribute('data-price'), 10) || 0;
          if (giftVariant && p.getAttribute('data-variant') === giftVariant) giftCardPrice += price;
          else eligible += price;
        });
        const giftFree = this.giftThreshold > 0 && giftCardPrice > 0 && eligible >= this.giftThreshold;
        const total = eligible + (giftFree ? 0 : giftCardPrice);
        const count = picks.length;

        const countEl = this.querySelector('[data-rb-count]');
        const totalEl = this.querySelector('[data-rb-total]');
        if (countEl) countEl.textContent = count + ' ' + (this.labels.products || '');
        if (totalEl) totalEl.textContent = this.fmt(total);

        const cta = this.querySelector('[data-rb-cta]');
        if (cta) {
          cta.textContent = (this.labels.cta || '') + ' — ' + this.fmt(total);
          cta.disabled = count === 0;
        }

        const goal = this.giftThreshold > 0 ? this.giftThreshold : this.shipThreshold;
        const fill = this.querySelector('[data-rb-fill]');
        if (fill && goal > 0) fill.style.width = Math.min(100, (eligible / goal) * 100) + '%';
        const shipOk = this.querySelector('[data-rb-ship-ok]');
        if (shipOk) shipOk.hidden = eligible < this.shipThreshold;
        const giftOk = this.querySelector('[data-rb-gift-ok]');
        if (giftOk) giftOk.hidden = this.giftThreshold === 0 || eligible < this.giftThreshold;

        const loss = this.querySelector('[data-rb-loss]');
        if (loss) {
          if (
            this.giftThreshold > 0 &&
            this.prevTotal !== null &&
            this.prevTotal >= this.giftThreshold &&
            eligible < this.giftThreshold
          ) {
            loss.textContent = this.labels.loss || '';
            loss.hidden = false;
          } else if (eligible >= this.giftThreshold) {
            loss.hidden = true;
          }
        }
        this.prevTotal = eligible;
      }

      toast(msg) {
        const el = this.querySelector('[data-rb-toast]');
        if (!el) return;
        el.textContent = msg;
        el.hidden = false;
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => { el.hidden = true; }, 6000);
      }

      async addAll(cta) {
        const picks = this.picks();
        if (!picks.length) return;
        const lvl = this.activeLevel();
        const items = picks.map((p) => ({
          id: parseInt(p.getAttribute('data-variant'), 10),
          quantity: 1,
          properties: { _routine: 'level-' + lvl },
        }));
        cta.disabled = true;
        let ok = 0;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (res.ok) {
            ok = items.length;
          } else {
            for (let i = 0; i < items.length; i++) {
              const r = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [items[i]] }),
              });
              if (r.ok) {
                ok++;
              } else {
                const card = picks[i].closest('.rb-prod');
                if (card) card.style.opacity = '0.4';
                picks[i].disabled = true;
                picks[i].checked = false;
              }
            }
            this.compute();
          }
        } catch (e) {}
        cta.disabled = false;
        if (ok === 0) {
          this.toast(this.labels.error || '');
          return;
        }
        if (ok < items.length) {
          this.toast((this.labels.addedPartial || '').replace('{ok}', ok).replace('{total}', items.length));
        } else {
          this.toast(this.labels.addedAll || '');
        }
        try {
          const cart = await fetch('/cart.js').then((r) => r.json());
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'routine-builder', data: { source: 'routine-builder', itemCount: cart.item_count } },
            })
          );
        } catch (e) {}
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          setTimeout(() => drawer.open(), 350);
        }
      }
    }
    customElements.define('routine-builder', RoutineBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
